import React, { useEffect, useState } from "react";
import "./collapsed-select.css";

const CollapsedSelect = ({
	name,
	label,
	value,
	options = [],
	placeholder = "Selecione uma opção",
	disabled = false,
	error = false,
	onChange,
	onBlur
}) => {
	const [isOpen, setIsOpen] = useState(false);

	const selectedOption = options.find(option => {
		return String(option.value) === String(value);
	});

	useEffect(() => {
		if (disabled) {
			setIsOpen(false);
		}
	}, [disabled]);

	const handleSelect = option => {
		if (disabled) {
			return;
		}

		onChange({
			target: {
				name,
				value: option.value
			}
		});

		setIsOpen(false);
	};

	return (
		<div
			className={[
				"collapse-select",
				isOpen ? "collapse-select--open" : "",
				error ? "collapse-select--error" : "",
				disabled ? "collapse-select--disabled" : ""
			].filter(Boolean).join(" ")}
		>
			<label className="collapse-select__label">
				{label}
			</label>

			<button
				type="button"
				className="collapse-select__trigger"
				onClick={() => !disabled && setIsOpen(previous => !previous)}
				onBlur={onBlur}
				disabled={disabled}
			>
				<span className="collapse-select__selected-text">
					{selectedOption?.label || placeholder}
				</span>

				<span className="collapse-select__arrow" />
			</button>

			{isOpen && (
				<div className="collapse-select__panel">
					{options.map(option => {
						const isSelected = String(option.value) === String(value);

						return (
							<button
								key={option.value}
								type="button"
								className={[
									"collapse-select__option",
									isSelected ? "collapse-select__option--selected" : ""
								].filter(Boolean).join(" ")}
								onMouseDown={event => event.preventDefault()}
								onClick={() => handleSelect(option)}
							>
								<span className="collapse-select__option-title">
									{option.label}
								</span>

								{option.description && (
									<span className="collapse-select__option-description">
										{option.description}
									</span>
								)}
							</button>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default CollapsedSelect;